<script>
import TheHeader from "@/components/index/TheHeader.vue";
import TheNav from "@/components/index/TheNav.vue";
export default {
  components: {
    TheHeader,
    TheNav
  },
  data() {
    return {
      routerAlive: true
    };
  },
  watch: {
    $route: function(to, from) {
      const divVar = document.getElementsByClassName("content")[0];
      divVar.scrollTop = 0;
      //   document.documentElement.scrollTop = 0;
    }
  },
  mounted() {
    this.$on("needRefreshRoute", data => {
      // console.log(">>>>>sssss>>>", data);
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    });
  },
  methods: {
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    }
  }
};
</script>

<template>
  <div class="Index">
    <TheHeader @routerRefresh="routerRefresh" />
    <div class="mainBody">
      <TheNav v-if="routerAlive" />
      <div class="content">
        <div>
          <router-view v-if="routerAlive" @routerRefresh="routerRefresh"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Index {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;

  .mainBody {
    // TODO: 这里有点不合理,但是暂时没有更好的办法
    height: calc(100vh - 64px);
    overflow: hidden;
    display: flex;

    .content {
      flex: 1;
      flex-grow: 1;
      margin: 15px;
      overflow-y: auto;

      > div {
        background-color: #fff;
        width: 100%;
        height: auto;
        border-radius: 5px;
        min-height: 95%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue